// extracted by mini-css-extract-plugin
module.exports = {"base":"Message_base__321Q4","title":"Message_title__FCKdN"};